import { clsx } from 'clsx';
import { OceanOfferFace, type OceanOfferType } from '../OceanOfferFace';
import styles from './OceanOfferHero.module.scss';

interface OceanOfferHeroProps {
  type: OceanOfferType;
  amount: number;
  numberOfRates: number;
}

// The offer's card at the top of its landing, glowing in its colour.
export function OceanOfferHero({ type, amount, numberOfRates }: OceanOfferHeroProps) {
  return (
    <div className={styles.root}>
      <div className={clsx(styles.shadow, styles[`shadow--${type}`])} aria-hidden />
      <OceanOfferFace
        type={type}
        amount={amount}
        numberOfRates={numberOfRates}
        className={styles.face}
      />
    </div>
  );
}
